class ContentFilter {
	constructor(filterBit, onUpdate) {
		this._filterBit = filterBit;
		this._onUpdate = onUpdate;
		this._memberships = null;
		this._popup = null;

		this.button = UI.priIconBtn('community', 18, {
			'mousedown': ev => stopEv(ev),
			'click': ev => this.open(ev)
		});
	}

	open(ev) {
		if (this._popup) {
			this._popup.handle(this.button);
			if (this._memberships !== null) return;
		}

		API.fetch('memberships')
		.then(reply => {
			if (showError(reply)) return;
			this._memberships = (reply.memberships || [])
				.filter(m => parseInt(m.unit_type) !== Nav.CIRCLE);

			this._popup = Dialog.Popup(
				UI.div('p-3 flex flex-col gap-2', this._memberships.length
					? this._memberships.map(m => this.buildRow(m))
					: UI.div('text-neutral-500 text-sm', _('No community memberships'))
				)
			).sticky();
			this._popup.handle(this.button);
		});
	}

	buildRow(m) {
		let filter = parseInt(m.content_filter);
		let chk = UI.chk(null, {
			'change': () => this.toggle(m, chk)
		});
		chk.checked = (filter & (1 << this._filterBit)) > 0;
		return UI.toggle(chk, UI.span('text-xs', m.unit_name));
	}

	toggle(m, chk) {
		let filter = parseInt(m.content_filter);
		if (chk.checked) {
			filter |= (1 << this._filterBit);
		} else {
			filter &= ~(1 << this._filterBit);
		}
		m.content_filter = filter;

		API.update(`memberships/${m.unit_id}`, {
			content_filter: filter
		})
		.then(reply => {
			if (showError(reply)) {
				chk.checked = !chk.checked;
				return;
			}
			if (this._onUpdate) this._onUpdate();
		});
	}
}
